import React, { createContext, useContext } from "react";

type CatalogItemEditContextValue = {
    isCatalogItemEditing: boolean;
    setCatalogItemEditing: (editing: boolean) => void;
};

export const CatalogItemEditContext = createContext<CatalogItemEditContextValue>({
    isCatalogItemEditing: false,
    setCatalogItemEditing: () => {},
});

export const useCatalogItemEditContext = () => useContext(CatalogItemEditContext);
